import { observer } from "mobx-react-lite";
import * as React from "react";
import { useStore } from "../root-store-context";
import { Spin, Typography } from "antd";
import { useEffect } from "react";
import { StepByStepTab } from "./StepByStepTab";
import { ModalFileViewer } from "./ModalFileViewer/ModalFileViewer";

const { Text } = Typography;

export const Main = observer(() => {
  const {
    applicationStore,
    modalViewerStore,
    stepByStepTabStore,
  } = useStore();

  useEffect(() => {
    applicationStore.onInit();
  }, []);

  useEffect(() => {
    stepByStepTabStore.setActiveTabs();
  }, [applicationStore.mailJob?.files]);

  useEffect(() => {

    const params = new URLSearchParams(window.location.search);
    const openJoblist = params.get("openJoblist");
    const jobId = params.get("jobId");

    if (openJoblist === "true" && jobId && jobId !== "") {
      applicationStore.setIsOpenData(jobId);
    }
  }, []);

  return (
    <>
      {applicationStore.communicationType.comTypeId != null && (
        <Text style={{ fontSize: "12px", display: "block" }}>
          Communication Type - {applicationStore.communicationType.comTypeName}
        </Text>
      )}
      &emsp;
      {applicationStore.communicationType.comTypeId === 1 && (
        <Text type="danger" style={{ fontSize: "12px" }}>
          Only one property can be processed at a time when selecting the
          General Correspondence option. When uploading documents, please
          upload in the order in which you wish them to be printed.
        </Text>
      )}
      <Spin spinning={applicationStore.isLoading}>
        <StepByStepTab />
      </Spin>
      <ModalFileViewer
        isOpenModal={modalViewerStore.isOpenModal}
        dismissModal={modalViewerStore.dissmissModal}
        urlModal={modalViewerStore.urlModal}
        isImage={modalViewerStore.isLocalFileForIframe}
        documentName={modalViewerStore.documentName}
      />
    </>
  );
});